module.exports = __webpack_public_path__ + "static/media/optionViewDarkCrossed.8a084806.svg";